/*!
 web2sign (entry points)
 (c) 2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

require('shim');
window.jQuery = require('jquery');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui-touch-punch'); // requires window.jQuery
require('jquery/center');
require('jquery/delay');
require('jquery/postJSON');
require('jquery/triggerSafe');
require('leaflet/src/layer/vector/Renderer.getRenderer'); // needed for any vector shape
require('leaflet/src/map/handler/Map.Drag');
require('leaflet/src/map/handler/Map.Keyboard');
require('leaflet/src/map/handler/Map.BoxZoom');
require('leaflet/src/map/handler/Map.TouchZoom');
require('leaflet/pr6118');
require('leaflet/Map/ScrollWheelScroll');
require('license');
window.w2s = { // for usage in the hook
    log: require('log').default,
    state: require('state').default,
    i18n: require('i18n-setup'),
    overlay: require('overlay'),
    init: require('init').selectInitialFile, // gets deleted after init by script.js
    doc: require('doc')
};
